import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ANNUAL_PLAN_OLD_PRICE } from '~/constants/products';
import { Typographies } from '~/theme/typography';
import { ProductType, REGULARITY } from '~/types/product';

import styles from './styles.module.scss';

type Props = {
  product: ProductType;
};

const PricingSummary: FC<Props> = ({ product }) => {
  const { t } = useTranslation('general');

  return (
    <div className={styles.pricing}>
      <Typography
        variant={Typographies.TITLE_MEDIUM}
        component="div"
        className={styles.pricing__periodically}
      >
        {product.regularity === REGULARITY.YEAR ? (
          <>
            {t('general:only', 'Only')} {(product.price / 100 / 12).toFixed(2)}{' '}
            {product.currency}/{t('general:month', 'Month').toLowerCase()}
          </>
        ) : (
          <>
            {product.currency}
            {(product.price / 100).toFixed(2)}/
            {t(
              `general:${product.regularity}`,
              `${product.regularity.charAt(0).toUpperCase() + product.regularity.slice(1)}`,
            ).toLowerCase()}
          </>
        )}
      </Typography>

      <Typography
        variant={Typographies.LABEL_MEDIUM}
        component="div"
        className={styles.pricing__summary}
      >
        {product.regularity === REGULARITY.YEAR ? (
          <>
            <span>{ANNUAL_PLAN_OLD_PRICE}</span>
            {product.price / 100} {product.currency}/
            {t('general:year', 'Year').toLowerCase()},{' '}
            {t('general:billed_annually', 'Billed Annually').toLowerCase()}
          </>
        ) : (
          <>
            <span>
              {(product.old_price_ui <= product.price
                ? product.price * 2
                : product.old_price_ui) / 100}
              {product.currency}
            </span>
            , {t('general:billed_monthly', 'Billed Monthly').toLowerCase()}
          </>
        )}
      </Typography>
    </div>
  );
};

export default PricingSummary;
